// AuthInviteAccessFlow (contract 06 §8): guard both present → request access → success toast.
// Missing args OR any error → a generic retry toast (never leaks why). Returns a toast outcome
// rather than throwing — the invite screen is a dead-end that only shows one of two toasts.
import { authService, type AuthService } from '../service/AuthService'

export type InviteOutcome = { ok: true; toast: 'requestSent' } | { ok: false; toast: 'retryLater' }

export interface AuthInviteAccessDeps {
  service?: AuthService
}

export class AuthInviteAccessFlow {
  private readonly service: AuthService

  constructor(deps: AuthInviteAccessDeps = {}) {
    this.service = deps.service ?? authService
  }

  async requestAccess(accountId: string, adminEmail: string): Promise<InviteOutcome> {
    const normalizedAccountId = accountId.trim()
    const normalizedAdminEmail = adminEmail.trim()
    if (!normalizedAccountId || !normalizedAdminEmail) {
      return { ok: false, toast: 'retryLater' }
    }
    try {
      await this.service.requestInviteAccess(normalizedAccountId, normalizedAdminEmail)
      return { ok: true, toast: 'requestSent' }
    } catch {
      return { ok: false, toast: 'retryLater' }
    }
  }
}
